module.exports = __webpack_public_path__ + "img/meter-bolt.97df92a6.svg";